import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import { ErrorDetailPage } from './error-detail/ErrorDetailPage'
import {Wizard} from './wizard/Wizard'

const UploadFilePage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/new'
          element={
            <Wizard />
          }
        />
        <Route
          path='/users-with-error'
          element={
            <ErrorDetailPage />
          }
        />
      </Route>
      <Route index element={<Navigate to='/upload-file/new' />} />
    </Routes>
  )
}

export default UploadFilePage
